<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="contract.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Контрагент</label>
            <crm-contragent-auto-complete
              [(selectedContragent)]="contract.contragent"
              [isError]="$any(errors?.contragent)"
              [clientId]="clientId"
              [showClear]="true"
              [customSearch]="false"
              appendTo="body"></crm-contragent-auto-complete>
            <small
              *ngIf="errors?.contragent"
              class="p-error">
              {{ errors.contragent }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Компания</label>
            <crm-company-single-select
              [(selectedCompany)]="contract.company"
              [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-company-single-select>
            <small
              *ngIf="errors?.company"
              class="p-error">
              {{ errors.company | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Номер</label>
            <crm-input-text
              [(value)]="contract.number"
              [isError]="$any(errors?.number)"></crm-input-text>
            <small
              *ngIf="errors?.number"
              class="p-error">
              {{ errors.number | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Бюджетная статья</label>
            <crm-direction-single-select
              [directions]="directions"
              [(selectedDirection)]="contract.direction"
              [groupsDisabled]="true"
              [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [showClear]="true"
              appendTo="body">
            </crm-direction-single-select>
            <small
              *ngIf="errors?.direction"
              class="p-error">
              {{ errors.direction | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Бизнес единица</label>
            <crm-unit-single-select
              [(selectedUnit)]="contract.unit"
              [isError]="$any(errors?.unit)"
              [showClear]="true"
              appendTo="body"></crm-unit-single-select>
            <small
              *ngIf="errors?.unit"
              class="p-error">
              {{ errors.unit | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Филиал</label>
            <crm-filial-single-select
              [(selectedFilial)]="contract.filial"
              [isError]="$any(errors?.filial)"
              appendTo="body"
              [showClear]="true"></crm-filial-single-select>
            <small
              *ngIf="errors?.filial"
              class="p-error">
              {{ errors.filial | join }}
            </small>
          </div>

          <div
            *ngIf="accessService.finance.dealRights.canReadDeal"
            class="field">
            <label class="font-medium">Сделка</label>
            <crm-deal-auto-complete
              [(selectedDeal)]="contract.deal"
              [isError]="$any(errors?.deal)"
              appendTo="body"></crm-deal-auto-complete>
            <small
              *ngIf="errors?.deal"
              class="p-error">
              {{ errors.deal | join }}
            </small>
          </div>

          <div
            *ngIf="accessService.finance.dealRights.canReadDeal"
            class="field">
            <label class="font-medium">Шаблон документа</label>
            <crm-document-file-template-single-select
              [(selectedEntity)]="contract.documentFileTemplate"
              [styleClass]="errors?.documentFileTemplate ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.documentFileTemplate ? 'ng-invalid ng-dirty' : ''"
              [showClear]="true"
              appendTo="body">
            </crm-document-file-template-single-select>
            <small
              *ngIf="errors?.documentFileTemplate"
              class="p-error">
              {{ errors.documentFileTemplate | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Центр затрат</label>
            <crm-cost-center-single-select
              [(selectedCostCenter)]="contract.costCenter"
              [isError]="$any(errors?.costCenter)"
              appendTo="body"></crm-cost-center-single-select>
            <small
              *ngIf="errors?.costCenter"
              class="p-error">
              {{ errors.costCenter | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Дата</label>
            <crm-datepicker
              [(value)]="contract.date"
              [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.date"
              class="p-error">
              {{ errors.date | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Срок действия</label>
            <crm-datepicker
              [(value)]="contract.expiresAt"
              [inputStyleClass]="errors?.expiresAt ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.date"
              class="p-error">
              {{ errors.date | join }}
            </small>
          </div>

          <div class="field-checkbox mb-0">
            <p-checkbox
              [(ngModel)]="contract.ignoreInAnalytics"
              [binary]="true"
              inputId="ignoreInAnalytics"></p-checkbox>
            <label [for]="'ignoreInAnalytics'">Не учитывать документы в аналитике</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveContract()"></crm-button>

      <crm-button
        *ngIf="(form$ | async)?.isEdit"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteContract()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
